import { http } from '@/utils/Http'

export default {
  install (Vue) {
    Vue.prototype.$http = http
    Vue.http = http
  },
}
